<template>
    <div class="list-content border-radius5">
        <div class="title">{{$t('Basic_Information')}}</div>
        <p class="card-line">
            <span>{{$t('User.login')}}</span>
            <span class="line"></span>
            <span>
                  {{accountInfo.login}}
            </span>
        </p>
        <div class="card-line">
            <span>{{$t('User.transactionStatus')}}</span>
            <span class="line"></span>
            <span>
                <mt4-status
                        :account-info="accountInfo"
                ></mt4-status>
            </span>
        </div>
        <p class="card-line">
            <span>{{$t('User.accType')}}</span>
            <span class="line"></span>
            <span>
                        {{accountInfo.accType}}
                        </span>
        </p>
        <p class="card-line">
            <span>{{$t('User.leverage')}}</span>
            <span class="line"></span>
            <span>
                    1:{{accountInfo.leverage}}
                </span>
        </p>
        <!--            v-if="accountType=='real'"-->
        <p class="card-line">
            <span>{{$t('User.reportBanlance')}}</span>
            <span class="line"></span>
            <span class="theme-font">
                            {{accountInfo.balance}}
                        </span>
        </p>
        <!--<p class="card-line">
            <span>{{$t('User.currency')}}</span>
            <span class="line"></span>
            <span>
                            {{accountInfo.depCurrency || 'USD'}}
                        </span>
        </p>-->
        <p class="card-line">
            <span>{{$t('User.reportEquity')}}</span>
            <span class="line"></span>
            <span>
                    {{accountInfo.equity}}
                </span>
        </p>
        <p class="card-line">
            <span>{{$t('User.credit')}}</span>
            <span class="line"></span>
            <span>
                    {{accountInfo.credit}}
                </span>
        </p>
        <p class="card-line">
            <span>{{$t('User.marginFree')}}</span>
            <span class="line"></span>
            <span>
                   {{accountInfo.marginFree}}
                </span>
        </p>
        <p class="card-line">
            <span>{{$t('User.profitRate')}}</span>
            <span class="line"></span>
            <span>
                   {{accountInfo.profitRate}}
                </span>
        </p>
        <p class="card-line">
            <span>{{$t('Total_deposit')}}</span>
            <span class="line"></span>
            <span>
                    {{accountInfo.totalDeposit}}
                </span>
        </p>
        <p class="card-line">
            <span>{{$t('Total_withdrawal')}}</span>
            <span class="line"></span>
            <span>
                    {{accountInfo.totalWithdraw}}
                </span>
        </p>
        <p class="card-line">
            <span>{{$t('User.openOrder')}}</span>
            <span class="line"></span>
            <span>
                    {{accountInfo.openOrder}}
                </span>
        </p>
        <p class="card-line">
            <span>{{$t('User.closeOrder')}}</span>
            <span class="line"></span>
            <span>
                {{accountInfo.closeOrder}}
            </span>
        </p>
        <p class="card-line">
            <span>{{$t('User.createTime')}}</span>
            <span class="line"></span>
            <span>
                {{accountInfo.createTime && accountInfo.createTime.split(' ')[0]}}
            </span>
        </p>
    </div>
</template>

<script>
  import mt4Status from '@/components/public/mt4Status'
  import { queryStatistics,queryStatisticsSimple } from '@/api/copy'
  export default {
    name: 'accountIndexData',
    components:{
      mt4Status,
    },
    data() {
      return {
        accountInfo: {
          balance: 0,
          closeOrder: 3,
          createTime: "",
          credit: 0,
          earningRate: 0,
          enableReadOnly: 0,
          equity: 0,
          leverage: 0,
          login: 0,
          marginFree: 0,
          maxRetracement: 0,
          openOrder: 0,
          profitRate: 0,
          statProfit: 0,
          subLoginNumber: 1,
          times: 1,
        }
      };
    },
    created(){
      this.getStatisticsData();
    },
    computed: {
      disabledStyle(){
        if(this.accountInfo.businessType !== 6){
          return {
            width: '300px'
          }
        }else {
          return {};
        }
      },
    },
    methods: {
      getStatisticsData() {
        if(this.$route.name == 'mamMasterDetailsSimple' || this.$route.name == 'socialMasterDetailsSimple'){
          queryStatisticsSimple({
            mtId: this.$route.params.mtid,
          }).then((res) => {
            this.accountInfo = res.data[0];
            this.$emit('send-indexdata', this.accountInfo);
          })
        }else {
          queryStatistics({
            mtId: this.$route.params.mtid,
          }).then((res) => {
            this.accountInfo = res.data[0];
            this.$emit('send-indexdata', this.accountInfo);
          })
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.list-content {
    padding: 30px;
    margin-bottom: 10px;
    background-color: #ffffff;
    .title {
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .first {
        padding: 0 20px;
        padding-top: 20px;
        padding-bottom: 15px;
        border-bottom: 1px dashed #DFDFDF;
        .tag-box {
            padding-top: 15px;
        }
    }
    .card-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 28px;
        font-size: 13px;
        .line {
            flex: 1;
            height: 0;
            border-bottom: 1px dashed #E6E6E6;
            margin: 0 5px;
        }

        & > span {
            display: block;

            .icon {
                display: block;
                cursor: pointer;
                width: 16px;
                height: 16px;
            }

            &:last-of-type {
                white-space: nowrap;
            }
        }
        &.status {
            margin: 20px 0;
        }
    }
}
</style>
